<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            审批权限配置
        </div>
        <div style="padding: 20px;">

            <div class="setGov">
                <div style="height: 10px;"></div>

                <div :style="contentStyleObj">
                    <template>
                        <el-row class="setBody">
                            <el-col :span="24" class="item" style="text-align:center">
                                <h2>{{GovName}}</h2>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-card class="box-card card" shadow='hover' :loading='spLoading'>
                                    <div slot="header" class="clearfix">
                                        <span>设置审批权限</span>
                                        <el-button type="primary" icon="el-icon-finished" class="setButton" plain @click="append">选择等级</el-button>
                                    </div>
                                    <el-col :span="24" style="text-align:center">
                                        <h3>{{levelName}}</h3>
                                    </el-col>
                                </el-card>
                            </el-col>
                            <!-- <el-col :span="12" class="item">
                                <el-card class="box-card card" shadow='hover'>
                                    <div slot="header" class="clearfix">
                                        <span>设置政府角色</span>
                                        <el-button type="primary" icon="el-icon-user" class="setButton" plain @click="role">选择角色</el-button>
                                    </div>
                                    <el-col :span="24" style="text-align:center">
                                        <h3>{{topRoleName}}</h3>
                                    </el-col>
                                </el-card>
                            </el-col> -->
                        </el-row>
                        <el-dialog title="角色选择" :visible.sync="dialogFormVisible" width='500px' center top='35vh'>
                            <el-row>
                                <el-col :span="24" class="item">
                                    <el-select v-model="roleCode" placeholder="请选择角色" style="width:100%">
                                        <el-option
                                                v-for="item in roleValue"
                                                :key="item.roleCode"
                                                :label="item.name"
                                                :value="item.roleCode">
                                        </el-option>
                                        <!-- <el-option label="区域一" value="shanghai"></el-option> -->
                                        <!-- <el-option label="区域二" value="beijing"></el-option> -->
                                    </el-select>
                                </el-col>
                            </el-row>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible = false">取 消</el-button>
                                <el-button type="primary" @click="setRole">确 定</el-button>
                            </div>
                        </el-dialog>
                    </template>
                </div>

            </div>

        </div>
        <LevelTree ref="myLevelTree" v-show="showModalLevelTree" v-on:showModal="showModal" v-bind:listZoneDTO="listZoneDTO" v-on:setLevel="setLevel"></LevelTree>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import LevelTree from "./LevelTree"

    export default {
        name: "Set",
        components:{LevelTree},
        data() {
            return {

                spLoading:false,
                dialogFormVisible:false,
                GovName:'',
                governmentCode:'',
                listZoneDTO:[],
                showModalLevelTree:false,
                level:'',
                levelName:'未设置',
                topRoleName:'未设置',
                roleCode:'',
                roleValue:[],
                lvName:'',
                th:0,
                contentStyleObj: {
                    padding:'0px',
                    backgroundColor:'#fff',
                    overflowY:'auto',
                    height: ''
                },
            }
        },
        created(){
            this.init();
            this.th = this.$store.state.tableHeight;
            this.contentStyleObj.height = this.th +50 +"px";

        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
                this.contentStyleObj.height = this.th+50 +"px";
            },
        },


        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/Get",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        // this.loading = false;
                        if (response.data.error == 0) {
                            this.GovName = response.data.data.name;
                            this.governmentCode = response.data.data.governmentCode;
                            this.level = response.data.data.elderlyLastAuditZoneLevel;
                            this.topRoleName = response.data.data.roleName;
                            this.roleCode = response.data.data.topRoleCode;
                            this.menuShow();
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            // init(){
            //     this.$axios({
            //         method: 'post',
            //         url: this.$shopUrl+"Government/Get",
            //         data: {
            //             timeStr: timeStr,
            //             sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            //             staffCode: getStaffCode(),
            //         }
            //     }).then(
            //         (response) => {
            //             // this.loading = false;
            //             if (response.data.error == 0) {
            //                 this.GovName = response.data.data.name;
            //                 this.governmentCode = response.data.data.governmentCode;
            //                 this.level = response.data.data.elderlyLastAuditZoneLevel;
            //                 this.topRoleName = response.data.data.roleName;
            //                 this.roleCode = response.data.data.topRoleCode;
            //                 this.menuShow();
            //             }else if(response.data.error == 1){
            //                 this.$message(response.data.message);
            //             }

            //         }
            //     )
            //     this.getDownloadQZ()
            // },
            menuShow(){
                this.loading = true;
                // this.$axios({
                //     method: 'post',
                //     url: this.$shopUrl+"Role/ListGov",
                //     data: {
                //         timeStr: timeStr,
                //         sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                //         staffCode: getStaffCode(),
                //     }
                // }).then(
                //     (response) => {
                //         this.loading = false;
                //         if (response.data.error == 0) {
                //             console.log(response.data.data)
                //             var roleValue = response.data.data;
                //             var index=-1;
                //             for (var i = 0; i < roleValue.length; i++) {
                //                 if (roleValue[i].name == '商家') index=i;
                //             }
                //             roleValue.splice(index, 1);
                //             this.roleValue=roleValue
                //         }else if(response.data.error == 1){
                //             this.$message(response.data.message);
                //         }else{
                //             console.log(response.data.message);
                //         }

                //     }
                // )
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            var data = response.data.data;
                            if(data.length>0){
                                let aa =  JSON.stringify(data).replace(/listZoneDTO/g,"children");
                                aa = JSON.parse(aa);
                                var lvcj=["省民政","市民政","县区民政","街道民政","居委会"];
                                this.listZoneDTO=this.editZoneVlue(aa,lvcj);
                                var children=this.listZoneDTO[0];
                                this.listZoneDTO[0].name=children.lvcj[children.lv-1]+'('+children.name+')';
                                this.lvName=children.lvcj
                                this.levelName=this.level+"级"+this.lvName[this.level]
                            }else{
                                this.listZoneDTO=[{
                    name: '未添加组织'}]
                            }
                            
                            console.log(this.listZoneDTO)
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            editZoneVlue(list,lvcj){
                var LvList=[{
                    level:'',
                    name:'',
                    lv:'',
                    lvcj:'',
                    children:[],
                }]
                for(var i in list){
                    LvList[0].level=list[0].level;
                    LvList[0].name=list[0].name;
                    if(list[i].children){
                        if(list[i].children.length>0){
                            LvList[0].children=this.editZoneVlue(list[i].children,lvcj)
                            var children=LvList[0].children[0];
                            if(children.lv>0){
                                if(!children.lvcj){
                                    LvList[0].lvcj=lvcj.slice(-children.lv);
                                }else{
                                    LvList[0].lvcj=children.lvcj
                                }
                                LvList[0].children[0].name=LvList[0].lvcj[children.lv-1]+'('+children.name+')';
                                LvList[0].lv=children.lv-1;
                            }
                        }else{
                            LvList[0].lv=LvList[0].level+1;
                        }
                    }else{
                        LvList[0].lv=LvList[0].level+1;
                    }
                }
                return LvList;
            },
            append() {
                this.showModalLevelTree = !this.showModalLevelTree;
                this.$refs.myLevelTree.init();
            },
            role() {
                this.dialogFormVisible =true;
            },
            showModal() {
                this.showModalLevelTree = !this.showModalLevelTree;
            },
            setRole(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/SetRole",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        topRoleCode: this.roleCode,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            console.log( response.data.data.name)
                            this.init();
                            this.dialogFormVisible = false
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            updateMune(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/EditLastAuditZoneLevel",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        governmentCode: this.governmentCode,
                        level: this.level,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            // console.log( response.data.data.name)
                            this.levelName=this.level+"级"+this.lvName[this.level];
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            setLevel(level){
                this.level=level
                // this.levelName=level+"级"+this.lvName[level];
                this.updateMune();
            }

        },

    }

</script>


<style lang="scss" scoped>

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        padding-right: 8px;
    }
    .el-button--text{
        font-size: 16px;
    }
    .el-tree-node__content{
        height: auto;
    }
    .sp{
        margin-right: 20px;
    }
    .setBody .el-card__body{
        padding:10px 20px;
    }
    .card{
        height: 150px;
    }
    .setButton{
        float: right;
        transform: translate(0px, -9px);
    }
    .setGov /deep/ .el-dialog{
        border-radius: 10px;
    }
</style>

